import { render, staticRenderFns } from "./PrintLabelDialog.vue?vue&type=template&id=b267c46e"
import script from "./PrintLabelDialog.vue?vue&type=script&lang=js"
export * from "./PrintLabelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports